import { createContext, memo, ReactNode, useCallback, useContext } from "react";
import { matchRoutes } from "react-router-dom";
import { useRoutesContext } from "./RoutesContext";
import { RouteDescription } from "./types";
import { getRoutePermissions } from "./utils";

type PathPermissionChecker = (path?: string) => {
  requiredPermissions: string | string[]
  requiredOneOfPermissions: string | string[]
}

const PathPermissionsContext = createContext<PathPermissionChecker>(() => ({
  requiredPermissions: [],
  requiredOneOfPermissions: [],
}));

export const PathPermissionsContextProvider = memo<{ children: ReactNode | ReactNode[] }>(({ children }) => {
  const routes = useRoutesContext();

  const checker: PathPermissionChecker = useCallback((path?: string) => {
    const correspondingRoute = matchRoutes(routes, path || "")
      ?.pop();

    if (correspondingRoute) {
      return getRoutePermissions(correspondingRoute.route as RouteDescription, correspondingRoute.params as any);
    }

    console.warn("No corresponding route for path", path);
    return ({
      requiredPermissions: [],
      requiredOneOfPermissions: [],
    });
  }, [ routes ]);

  return (
    <PathPermissionsContext.Provider value={checker}>
      {children}
    </PathPermissionsContext.Provider>
  );
});

export const useGetPathPermissionChecker = () => useContext(PathPermissionsContext);
